/*
 * @Description: 活动中心作品详情
 * @Author: liuwp
 * @Date: 2022-10-20 17:56:17
 * @LastEditors: liuwp
 * @LastEditTime: 2022-10-20 18:19:33
 */
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

export const getWorkDetailApi = (id) => {
  return apiBaseUrl.get(`/ac/admin/works/detail-audit/${id}`);
};
